// extracted by mini-css-extract-plugin
export default {"dark-mode":"About_dark-mode__O0FGT","header":"About_header__3gBKW","ListItem":"About_ListItem__+p5dk","about-wrapper":"About_about-wrapper__fHbqi"};